module.exports = __webpack_public_path__ + "img/startConfigurationAttachmentSetting@2x.a5553a0.png";